import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { useMerchant } from "context/merchant";
import { login } from "./api/authApi";

const LoginSchema = Yup.object().shape({
  loginName: Yup.string().required("Нэвтрэх нэр шаардлагатай"),
  loginPassword: Yup.string().required("Нууц үг шаардлагатай"),
});

export default function LoginScreen() {
  const navigate = useNavigate();
  const { saveMerchantInfo } = useMerchant();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      loginName: "",
      loginPassword: "",
      rememberMe: true,
    },
    validationSchema: LoginSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const result = await login({
          loginName: values.loginName,
          loginPassword: values.loginPassword,
          role: "merchant",
        });

        const { success, message, data } = result;
        if (success) {
          saveMerchantInfo(data);
          localStorage.setItem("token", data.token);
          toast.success(message);
          navigate("/menu/orders");
        } else {
          toast.error(message || "Нэвтрэхэд алдаа гарлаа.");
        }
      } catch (error) {
        toast.error(error?.message || "Серверийн алдаа.");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="auth-fluid">
      <div className="auth-fluid-form-box">
        <div className="card-body d-flex flex-column h-100 gap-3">
          <div className="my-auto">
            <h4 className="mt-0">Нэвтрэх</h4>
            <p className="text-muted mb-4">
              Бүртгэлтэй нэвтрэх нэр болон нууц үгээ оруулан нэвтэрнэ үү
            </p>
            <form onSubmit={formik.handleSubmit}>
              <div className="mb-3">
                <input
                  className={`form-control ${
                    formik.errors.loginName && formik.touched.loginName
                      ? "is-invalid"
                      : ""
                  }`}
                  type="text"
                  name="loginName"
                  placeholder="Нэвтрэх нэр"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.loginName}
                />
                {formik.errors.loginName && formik.touched.loginName ? (
                  <div className="invalid-feedback">
                    {formik.errors.loginName}
                  </div>
                ) : null}
              </div>
              <div className="mb-3 position-relative">
                <input
                  className={`form-control ${
                    formik.errors.loginPassword && formik.touched.loginPassword
                      ? "is-invalid"
                      : ""
                  }`}
                  type={showPassword ? "text" : "password"}
                  name="loginPassword"
                  placeholder="Нууц үг"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.loginPassword}
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary position-absolute end-0 top-50 translate-middle-y m-0 border-0"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ marginRight: "10px" }}
                >
                  {showPassword ? (
                    <i className="ri ri-eye-off-line" />
                  ) : (
                    <i className="ri ri-eye-line" />
                  )}
                </button>
                {formik.errors.loginPassword && formik.touched.loginPassword ? (
                  <div className="invalid-feedback">
                    {formik.errors.loginPassword}
                  </div>
                ) : null}
              </div>
              <div className="mb-3">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="checkbox-signin"
                    onChange={formik.handleChange}
                    name="rememberMe"
                    checked={formik.values.rememberMe}
                  />
                  <label className="form-check-label" htmlFor="checkbox-signin">
                    Сануулах
                  </label>
                </div>
              </div>
              <div className="d-grid mb-0 text-center">
                <button
                  className="btn btn-primary"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span className="ms-2">Түр хүлээнэ үү...</span>
                    </>
                  ) : (
                    <>
                      <i className="mdi mdi-login" /> Нэвтрэх
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
          <footer className="footer footer-alt">
            <p className="text-muted">
              Цахим Эхлэл ХХК
              <a href="pages-register-2.html" className="text-muted ms-1">
                <b>@2025</b>
              </a>
            </p>
          </footer>
        </div>
      </div>
    </div>
  );
}
